import { Lightning } from "@lightningjs/sdk";
import { Helper } from "../lib/helper";

export default class ResumeButton extends Lightning.Component {

    _iconSrc: any;
    _focusedSrc: any;
    _label: any;
    _action: any;

    static override _template() {
        return {
            w: 150,
            h: 150,
            collision: true,
            flex: { direction: "column", alignItems: "center" },
            Icon: {
                w: 85,
                h: 85,
            },

            Label: {
                y: 12,
                alpha: 0,
                text: {
                    fontSize: 22,
                    textAlign: 'center',
                    fontFace: Helper.getFontFamily('Black')
                },
            }
        };
    }

    set iconSrc(v: any) {
        if (this._iconSrc === v) return;
        this._iconSrc = v;
        this._updateIcon();
    }

    set focusedSrc(v: any) {
        if (this._focusedSrc === v) return;
        this._focusedSrc = v;
        this._updateIcon();
    }

    set label(v: any) {
        if (this._label === v) return;
        this._label = v;
        this.tag('Label').text.text = v;
    }

    set action(v: any) {
        this._action = v;
    }

    _updateIcon() {
        const src = this.hasFocus() ? this._focusedSrc : this._iconSrc;
        if (!src) return;

        this.tag('Icon').texture =
            Lightning.Tools.getSvgTexture(src, 85, 85);
    }

    _updateFocusState(focused: boolean) {
        this._updateIcon();

        this.tag('Label').patch({
            alpha: focused ? 1 : 0,
        });
    }

    override _init() {
        this.tag('Label').text.text = this._label;
        this._updateIcon();
    }

    override _focus() {
        this._updateFocusState(true);
    }

    override _unfocus() {
        this._updateFocusState(false);
    }

    override _handleEnter() {
        if (this._action) {
            this.fireAncestors(this._action);
        }
        return true;
    }

    override _handleClick() {
        if (this._action) {
            this.fireAncestors(this._action);
        }
        return true;
    }
}
